/**
 * Checkbox Style  enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum CHECKBOX_STYLE {
	DEFAULT = "default",
	SWITCH = "switch"
}

export type CHECKBOX_STYLE_string = keyof typeof CHECKBOX_STYLE;
